// extracted by mini-css-extract-plugin
export var bubble = "_3i-0";
export var container = "_3i-f";
export var contrastBorder = "_3i-g";
export var greyOut = "_3i-2";
export var initialsColor0 = "_3i-3";
export var initialsColor1 = "_3i-4";
export var initialsColor10 = "_3i-d";
export var initialsColor11 = "_3i-e";
export var initialsColor2 = "_3i-5";
export var initialsColor3 = "_3i-6";
export var initialsColor4 = "_3i-7";
export var initialsColor5 = "_3i-8";
export var initialsColor6 = "_3i-9";
export var initialsColor7 = "_3i-a";
export var initialsColor8 = "_3i-b";
export var initialsColor9 = "_3i-c";
export var initialsWrapper = "_3i-1";
export var large = "_3i-l";
export var medium = "_3i-k";
export var mediumSmall = "_3i-j";
export var mediumSmallMedium = "_3i-o";
export var micro = "_3i-h";
export var small = "_3i-i";
export var tiny = "_3i-n";
export var xTiny = "_3i-m";